import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBrandingConfig } from 'helpers/fakebackend_helper';

// Fetch branding configuration (public endpoint, no auth required)
export const fetchBrandingConfig = createAsyncThunk(
  'BrandingConfiguration/fetchConfig',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBrandingConfig();
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Không thể tải thông tin thương hiệu'
      );
    }
  }
);